import axios from './axios'

export default class ContactService{
    static async save(formData){
        return await axios.post("/query/save",formData);
    }
};

